export default {
  productList: {
    total: "対象商品 {total} 件",
    filter: "フィルター",
    sortNum: "人気",
    sortPrice: "価格",
    sortEvaluate: "評価",
    sortNew: "新商品",
    filterCategory: "カテゴリ",
    filterBrand: "ブランド",
    filterTemperature: "保存方法",
    filterOrigin: "原産地",
    couponDetail: 'クーポン詳細',
    searchTitle: "{search}の検索結果",
    proTitle: "商品リスト",
    noProduct: "該当商品がありません！",
    allClear: 'クリア'
  },
  productDetail: {
    productDetail: '商品詳細',
    productStocknumTag: "在庫僅か",
    proRateNum: "レビュー{num} 件",
    countdownNum: "数量限定{num}件",
    countdownTime: "キャンペン終了まであと",
    countStarTime: "キャンペン開始まであと",
    proBrand: "ブランド",
    proCode: "品番",
    proTemperature: "運送方法",
    proOrigin: "原産地",
    proPoints: "付与ﾎﾟｲﾝﾄ",
    proCoupon: "ｸｰﾎﾟﾝ",
    proCouponMore: "クーポン一覧",
    proPromotion: "ｷｬﾝﾍﾟﾝ",
    proPromotionMore: "詳細",
    delivery: "配達先",
    deliveryTime: "最短納品日 {date}",
    proNum: "数量",
    proNoNum: "在庫切れ!",
    btnAddCart: "カートに入れる",
    arrivalNotice: "入荷通知",
    arrivalNoticeProp: "入荷通知を登録しました。商品入荷後にメールでお知らせします。",
    btnProOff: "終売",
    proCollection: "気に入り",
    proDescTitle: "商品詳細",
    proDescParam: "規格詳細",
    proReviews: "商品レビュー",
    proSaleTitle: "キャンペン商品",
    proLatelyTitle: "閲覧履歴",
    proCouponTitle: "クーポンの事前登録",
    proCouponBtnAdd: "すぐ登録",
    proCouponBtn: "登録済",
    proCouponBtnGo: "すぐ使用",
    disposals: "処分中",
    relatedgoods: "関連商品",
    couponLable: '登録可能なクーポン',
    couponLable1: '登録済',
    couponType1: '円OFF券',
    couponType2: '%OFF券',
    couponType3: '送料無料券',
    couponType1UseMoney_text1: '{useMoneyCondition}円以上{discountInfo}円OFF',
    couponType1NoUseMoney: '{discountInfo}OFF',
    couponType2UseMoney: '{useMoneyCondition}以上{discountInfo}%OFF',
    couponType2NoUseMoney: '{discountInfo}%OFF',
    couponType3UseMoney: '{useMoneyCondition}以上{discountInfo}送料無料',
    couponType3NoUseMoney: '{discountInfo}送料無料',
    freeTransportName: '{freetransportName}送料無料',
    couponProductType: '対象商品利用可能',
    couponProductType0: '全商品利用可能',
    couponProductType1: '対象商品利用可能',
    couponProductType2: '対象商品利用可能',
    freeTransportType: '{freeTransportAreaName}送料無料',
    freeTransportTypeYw: '{freeTransportAreaName}以外送料無料',
    receiveNum: 'お一人様{num}枚まで',
    useDate: '有効期限',
    dateInterval: '〜',
    dateSameDay: '登録日から {day} 日間有効',
    dateNextDay: '登録翌日から {day} 日間有効',
    receive: '登録',
    toUse: 'クーポン使用',
    CouponSuccess: '登録しました',
    CollectSuccess: '気に入りに登録しました。',
    CollectDeleteSuccess: '気に入りから外しました',
    fastReceiveDateTootip: 'システムはお届け先に基づいて納品日を自動予測します。納品時間はレジ画面で無料でご指定できます。*天候、交通状況などの不可抗力でご希望の納品時間に添えない場合がございますので、予めご了承ください。',
    noComments: 'レビューがありません',
    activitTextStart: 'キャンペン開始まであと',
    activitTextEnd: 'キャンペン終了まであと',
    day: '日',
    hour: '時間',
    minute: '分',
    second: '秒',
    all: '全商品',
    picture: '写真あり',
    praise: '満足',
    middle_feedback: '普通',
    negative_feedback: '残念',
    current: '選択した規格のレビューを見る',
    noEvaluate: 'レビューがありません',
    nodesc: '商品説明がありません'
  }
};